// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "stylesheets/" + chunkId + "." + {"166":"15c7ff26eb","585":"a18e2b92c3"}[chunkId] + ".min.css";
};